import React from 'react';

import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

const Copyright = (props) => {
  return (
    <Typography variant="body2" align="center">
      {`© ${new Date().getFullYear()} `}
      <Link 
        color="inherit" 
        href={props.href} 
        target="_blank" 
        rel="noopeneed noreferred" >
        <b>{props.children}</b>
      </Link>
    </Typography>
  );
}

export default Copyright;